import { ComponentPropsWithoutRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface BreadcrumbsProps extends ComponentPropsWithoutRef<'div'> {}
const Breadcrumbs = (props: BreadcrumbsProps) => {
    const { className = '', children, ...rest } = props;

    return (
        <div className={twMerge(`flex flex-wrap items-center gap-2`, className)} {...rest}>
            {children}
        </div>
    );
};

interface BreadCrumbProps extends LinkProps {}

const BreadCrumb = (props: BreadCrumbProps) => {
    const { className = '', ...rest } = props;

    return (
        <div className={'group flex items-center gap-2'}>
            <Link
                className={twMerge(
                    `text-sm font-medium text-blue-600 group-last-of-type:select-none group-last-of-type:text-black`,
                    className,
                )}
                {...rest}
            />
            <FontAwesomeIcon
                className={'text-gray-600 group-last-of-type:hidden'}
                icon={faChevronRight}
                size="xs"
            />
        </div>
    );
};

const Root = Breadcrumbs;
const Crumb = BreadCrumb;

export {
    Root,
    Crumb,
    //
    Breadcrumbs,
    BreadCrumb,
};
export type { BreadcrumbsProps, BreadCrumbProps };
